export const state = {
  showMessageNotif: null,
  fcWidgetMessengerConfig: null,
  fcOpened: false
}

export const mutations = {
  SET_MESSAGENOTIF(state, payload) {
    state.showMessageNotif = payload
  },
  SET_WIDGETMESSENGERCONFIG(state, payload) {
    state.fcWidgetMessengerConfig = payload
  },
  setFcOpened(state, payload) {
    state.fcOpened = payload
  }
}

export const actions = {
  setMessageNotif({ commit }, payload) {
    commit('SET_MESSAGENOTIF', payload)
  },
  setWidgetMessengerConfig({ commit }, payload) {
    commit('SET_WIDGETMESSENGERCONFIG', payload)
  },
  showNotifFreshchat(context) {
    if (window.fcWidget) {
      window.fcWidget.on('widget:loaded', function (resp) {
        window.fcWidget.on('message:received', function (data) {
          if (!window.fcWidget.isOpen()) window.fcWidget.close()
          context.commit('SET_MESSAGENOTIF', true)
        })

        window.fcWidget.on('unreadCount:notify', function (resp) {
           if (!window.fcWidget.isOpen()) window.fcWidget.close()
          context.commit('SET_MESSAGENOTIF', resp.count > 0)
        })
      })
    } 
  },
}
